require("core-js/modules/es6.regexp.replace");

module.exports = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }

  return string.charAt(0).toUpperCase() + string.substring(1);
};

module.exports.words = function (string, preserve) {
  if (!preserve) {
    string = string.toLowerCase();
  }

  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
    return m.toUpperCase();
  });
};